<template>
  <div v-show="isShow">
      <div class="go-page-box">
          <div class="text">{{ text }}</div>
          <div class="confirm">
              <div class="button" @click="handleClick">
                  <span>回首页</span>
              </div>
          </div>
      </div>
      <div class="shadow"></div>
  </div>
</template>

<script>
export default {
name: 'GoPageConfirm',
components: {
},
data(){
    return {
        isShow: false,
    }
},
methods:{
  handleClick(){
    this.$emit('handleClick')
  }
},
props:{
  text:{
      type: String,
      default: '该商品正在更新，敬请期待'
  }
}
}
</script>

<style scoped lang="scss">
.shadow {
  position: fixed;
  z-index: 111;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.3);
}
.go-page-box {
    width: 80%;
    max-width: 625px;
    line-height: 50px;
    margin: 0 auto;
    color: #000;
    background: #FFF;
    max-width: 625px;
    margin: 0 auto;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 20px;
    position: fixed;
    border-radius: 5px;
    top: 30%;
    z-index: 999;
    .text {
        font-size: 16px;
        padding: 20px 0;
        border-bottom: 1px solid rgba(0,0,0,0.05);
    }
    .confirm {
        display: flex;
        .button {
            text-align: center;
            width: 100%;
            font-size: 18px;
            color: #eb411f;
        }
    }
}
</style>
